import { FC } from 'react';
import './RetailComponent.scss';
import { RETAIL_LABELS } from './model';
import { VideoVimeoComponent } from '../../UI/VideoVimeoComponent/VideoVimeoComponent';

const RetailComponent: FC = () => {
	return (
		<div className='retail-container'>
			<h2 className='section-title'>{RETAIL_LABELS.title}</h2>
			<div className='content-container'>
				<div className='video-mask'>
					<VideoVimeoComponent
						autoplay
						videoId={RETAIL_LABELS.videoLink}
						videoTitle=''
						hash={RETAIL_LABELS.videoHash}
					></VideoVimeoComponent>
				</div>
				<div className='text-container'>
					<h3 className='section-subtitle'>{RETAIL_LABELS.content_subititle}</h3>
					<p className='highlight-subtitle'>{RETAIL_LABELS.highlight_content}</p>
					<p className='section-content'>{RETAIL_LABELS.content1}</p>
					<p className='section-content'>{RETAIL_LABELS.content2}</p>
				</div>
			</div>
		</div>
	);
};

export default RetailComponent;
